"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .quill {\n    background-color: ", ";\n    border: 1px solid\n      ", ";\n    position: relative;\n    border-radius: 5px;\n\n    .ql-toolbar {\n      background-color: ", ";\n      position: absolute;\n      z-index: 10;\n      border: 1px solid ", ";\n      width: 45px;\n      height: 45px;\n      border-radius: 4px;\n      visibility: ", ";\n      top: ", "px;\n      left: ", "px;\n    }\n\n    .ql-container {\n      border: none;\n      font-family: ", ";\n      color: ", ";\n      strong {\n        font-family: ", ";\n      }\n\n      .ql-editor{\n        padding: 8px 10px;\n      }\n    }\n  }\n  .description-limit {\n    font-size: 12px;\n    font-family: ", ";\n    color: ", ";\n    text-align: right;\n    margin-top: 5px;\n  }\n"])), _variables.GlobalColors.white, function (_ref) {
  var focus = _ref.focus,
      isRequired = _ref.isRequired;
  return focus ? _variables.GlobalColors.magenta_s2 : isRequired ? "red" : _variables.GlobalColors.gray_light;
}, _variables.GlobalColors.s2, _variables.GlobalColors.gray_light, function (_ref2) {
  var selection = _ref2.selection;
  return selection ? "visible" : "hidden";
}, function (_ref3) {
  var position = _ref3.position;
  return position.top;
}, function (_ref4) {
  var position = _ref4.position;
  return position.left;
}, _variables.FontFamily.AvenirNext, _variables.GlobalColors.deep_gray, _variables.FontFamily.Raleway_900, _variables.FontFamily.AvenirNext, _variables.GlobalColors.deep_gray);

exports.Container = Container;